import { ModuleDataDB, slotIsVisibleForUser } from '@app/common';
import { ModuleStateDB } from '../data/datatypes';
import { getVisibleSessionIdsForUser, slotIsFinished } from '../services/DecisionTreeService/DecisionTreeService';

/**
 * Check if a single slot is completed
 */
export const isSlotCompleted = (
    slotId: `slot_${string}`,
    slot: any,
    moduleState: ModuleStateDB | undefined,
    userProperties: string[],
    useTransientStateProperties: boolean
): boolean => {
    if (!moduleState) {
        return false;
    }

    // Skip slots not visible to user
    if (!slotIsVisibleForUser(userProperties, slot, moduleState.modifiers || [])) {
        return true; // Consider invisible slots as "completed" for progress purposes
    }

    const visibleSessionIds = getVisibleSessionIdsForUser(
        slot,
        moduleState.modifiers || [],
        userProperties
    );

    return slotIsFinished(
        slotId,
        visibleSessionIds,
        moduleState.finished || {},
        useTransientStateProperties
    );
};

/**
 * Check if all visible slots in a module are completed
 */
export const isModuleFullyCompletedBySlot = (
    moduleData: ModuleDataDB,
    moduleState: ModuleStateDB | undefined,
    userProperties: string[],
    useTransientStateProperties: boolean
): boolean => {
    if (!moduleState) {
        return false;
    }

    const slotIds = Object.keys(moduleData.slots);
    const allSlotsCompleted = slotIds.every(slotId => {
        const slot = moduleData.slots[slotId as `slot_${string}`];
        return isSlotCompleted(
            slotId as `slot_${string}`,
            slot,
            moduleState,
            userProperties,
            useTransientStateProperties
        );
    });

    // Also check if start and end sections are completed
    const startCompleted = !moduleData.startSection || moduleState.finished?.start === true;
    const endCompleted = !moduleData.endSection || moduleState.finished?.end === true;

    return allSlotsCompleted && startCompleted && endCompleted;
};
